<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap mb-3">
      <div class="d-flex items-center col-12 p-0 mt-3">
        <div class="col-lg-5 col-5 px-2 transaction">
          <v-select
            v-model="params.date"
            :reduce="(draw) => draw.data"
            label="label"
            :options="dateOptions"
          ></v-select>
        </div>
        <div class="">
          <button
            type="button"
            class="px-3 py-1 !rounded-md text-white border-[1px] border-white"
            style="flex-shrink: 0"
            @click="
              currentPage = 1;
            fetchHistory();
            "
          >
            {{ $t("transaction.all") }}
            {{ $t("transaction.search") }}
          </button>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-center align-items-center mx-auto my-5 text-white"
      v-if="isLoading"
    >
      <Loading
        size="24"
        class="px-2 py-0"
      />
      <span> {{ $t('loading') }} ... </span>
    </div>

    <DataTable
      v-if="!isLoading"
      :tableData="tableData"
      @getSlipData="fetchSlipData"
    />

    <p class="total-text">{{ $t('transaction.transactions') }} - {{ paginationData?.total }}</p>

    <!-- Pagination -->
    <Pagination
      align="center"
      :data="paginationData"
      @pagination-change-page="fetchHistory"
      :limit="3"
      class="history-pagination"
    />
    <!-- pagination  -->
    <!-- <van-pagination
      v-model="currentPage"
      :total-items="rows"
      :items-per-page="limit"
      :show-page-size="3"
      size="sm"
      force-ellipses
      class="history-pagination"
    >
      <template #prev-text>
        <van-icon name="arrow-left" />
      </template>
<template #next-text>
        <van-icon name="arrow" />
      </template>
<template #page="{ text }">{{ text }}</template>
</van-pagination> -->

    <!-- === Voucher History === -->
    <div class="col-4">
      <div
        class="modal fade"
        id="voucher-history"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered"
          role="document"
        >
          <div class="modal-content">
            <div
              class="text-center modal-cross"
              @click="closeModal"
            >X</div>
            <div class="modal-body p-0">
              <FBVoucher
                :type="type"
                :datas="datas"
                :slipId="slipId"
                :currentTime="bet_date"
                :isHistory="true"
                :is_result="is_result"
                :bingo_amount="bingo_amount"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/pages/frontend/components/DataTable.vue";
import FBVoucher from "@/pages/frontend/components/FBVoucher.vue";
import Pagination from "laravel-vue-pagination";
import { DateTime } from "luxon";
import { Loading } from "vant";
import { mapActions } from "vuex";

export default {
  components: {
    DataTable,
    FBVoucher,
    Loading,
    Pagination
  },
  data() {
    return {
      rows: 1,
      currentPage: 1,
      limit: 5,
      paginationData: {
        current_page: 1,
        last_page: 1,
        per_page: this.limit,
        total: 0,
        data: []
      },

      tableData: {
        headings: [
          "voucher.total_amount",
          "transaction.balance",
          "transaction.type",
          "transaction.status",
          "transaction.action_by",
          "voucher.bet_date",
        ],
        datas: [],
      },
      depositActive: false,
      withdrawActive: false,
      transactionType: "all",
      type: "maung",
      datas: [],
      slipId: null,
      bet_date: null,
      bingo_amount: null,
      is_result: false,
      isLoading: false,

      params: {
        draw: "",
        date: "",
      },
      dateOptions: [],
    };
  },
  methods: {
    setOneMonth() {
      this.dateOptions = [];
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59, 0);
        d.setDate(d.getDate() - i);
        this.dateOptions.push({
          label: DateTime.fromJSDate(d).toLocaleString(DateTime.DATE_SHORT),
          data: d.toISOString(),
        });
      }
      this.params.date = this.dateOptions[0]?.data || new Date().toISOString();
    },
    closeModal() {
      $("#voucher-history").modal("hide");
    },
    fetchSlipData(data) {
      console.log("DATA", data)
      this.type = data.type;
      this.datas = data.team_vouchers;
      this.bingo_amount = data.bingo_amount;
      this.slipId = data.voucher_id;
      this.is_result = data.isBet;
      this.bet_date = this.betTime(data.created_at);
      $("#voucher-history").modal("show");
    },
    betTime(time) {
      if (!time) return "";
      const myTime = DateTime.fromISO(time, { zone: "utc" });
      const targetZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const localTime = myTime.setZone(targetZone);
      return localTime.toFormat("LLL dd, yyyy hh:mm a");
    },
    async fetchHistory(page = 1, type = "all") {
      try {
        this.transactionType = type;
        this.isLoading = true;
        this.tableData.contents = [
          "amount",
          "current_amount",
          "type",
          "status",
          "by_user_name",
          "created_at",
        ];
        const response = await axios.post(
          "/transactions/get_by_solo",
          {
            page: page,
            limit: this.limit,
            user_id: this.$store.state.authUser.id,
            drawDate: this.params.date,
            type,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("RESPONSE", response)
        this.tableData.datas = response.data.data;
        for (let index = 0; index < this.tableData.datas.length; index += 1) {
          this.tableData.datas[index].created_at = this.betTime(
            this.tableData.datas[index].created_at
          );
          this.tableData.datas[index].amount = Number(
            this.tableData.datas[index].amount
          ).toLocaleString();
          this.tableData.datas[index].current_amount = Number(
            this.tableData.datas[index].current_amount
          ).toLocaleString();
        }
        this.isLoading = false;

        this.rows = response.data.total;
        const totalPages = Math.ceil(response.data.total / this.limit);
        this.paginationData = {
          current_page: page,
          last_page: totalPages,
          per_page: this.limit,
          total: response.data.total,
          data: response.data.data
        };
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    currentPage() {
      this.fetchHistory();
    },
  },
  async mounted() {
    this.setOneMonth();
    this.params.date = moment(new Date()).format("l");
    await this.fetchHistory();
  },
};
</script>

<style scoped>
.modal-cross {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  padding-top: 3px;
  margin-left: auto;
  color: white;
  cursor: pointer;
  margin-right: -9px;
  margin-top: -9px;
  background: rgb(228, 87, 87);
}
</style>
